var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4504 0.379582C17.7433 0.672475 17.7433 1.14735 17.4504 1.44024L10.9304 7.96024C9.86748 9.02314 8.13261 9.02314 7.06971 7.96024L0.549713 1.44024C0.256821 1.14735 0.256821 0.672474 0.549713 0.379581C0.842608 0.0866881 1.31748 0.0866881 1.61037 0.379581L8.13037 6.89958C8.60748 7.37669 9.39261 7.37669 9.86971 6.89958L16.3897 0.379582C16.6826 0.0866888 17.1575 0.0866888 17.4504 0.379582Z",
    fill: "#A4A9B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.36232454f091655f193bc26c037d694f.svg";
export { ForwardRef as ReactComponent };